import type { Category, RefProvider } from 'config/enums';
import type { ProviderConfig, TemplateLangMap } from 'config/providers';

const DEFAULT_LANGUAGE = 'en';

export type TemplateResolutionContext = {
  provider: RefProvider;
  category: Category;
  lang?: string;
  subId?: string;
};

export type TemplateResolutionInput = {
  context: TemplateResolutionContext;
  config: ProviderConfig;
};

function getCategoryTemplate(categoryTemplates: TemplateLangMap | undefined, language?: string): string | undefined {
  if (!categoryTemplates) {
    return undefined;
  }

  if (language && categoryTemplates[language]) {
    return categoryTemplates[language];
  }

  return categoryTemplates[DEFAULT_LANGUAGE];
}

export function resolveTemplateId({ context, config }: TemplateResolutionInput): string {
  const { lang, subId } = context;

  const pinnedCategory = subId ? config.subIdOverrides?.[subId]?.categoryOverride : undefined;
  const effectiveCategory = pinnedCategory ?? context.category;

  const templateId = getCategoryTemplate(config.templates[effectiveCategory], lang);

  if (templateId) {
    return templateId;
  }

  const { provider, category } = context;
  throw new Error(
    `Template resolution failed for provider=${provider}, category=${category}, lang=${lang || 'n/a'}, subId=${subId || 'n/a'}`,
  );
}
